import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 69 — "hire remote HubSpot expert" cluster service links.
 *
 * Every Batch 69 article routes its primary commercial link to
 * /hubspot-revops-architect. The answer-first leads in batch69Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /hubspot-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH69_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "hire-remote-hubspot-revops-architect": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal with no shared deal definition is a portal the forecast cannot trust/i,
    label: "hire a HubSpot RevOps architect",
  },
  "cost-to-hire-a-remote-hubspot-expert": {
    url: "/hubspot-revops-architect",
    anchor:
      /remote HubSpot expert whose rework costs the team a quarter is a hire the rate does not measure/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hire-remote-hubspot-consultant": {
    url: "/hubspot-revops-architect",
    anchor:
      /HubSpot portal built without a strategy is a portal the team rekeys every quarter/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hire-remote-hubspot-developer": {
    url: "/hubspot-revops-architect",
    anchor:
      /HubSpot portal with no custom code is a portal that hits the workflow ceiling/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hire-remote-hubspot-expert-vs-agency": {
    url: "/hubspot-revops-architect",
    anchor:
      /agency that rotates the manager is a partner the team rebriefs and a remote expert who owns the portal is a partner the team keeps/i,
    label: "hire a HubSpot RevOps architect",
  },
};
